import _get from 'lodash/get'
import Vue from 'vue'
import {TripDashboardStore} from "./_store_trip_dashboard";
import _find from 'lodash/find'
import * as O from '@effect-ts/core/Option'
import { TripDashboardViewModes } from '../TripDashboardPermissionBusConstants'

export default {
  state: {
    collection: _get(window, 'appInitialData.dashboards', []),
    currentTripDashboardId: null,
    tripLogo: null
  },
  mutations: {
    switchCurrentDashboard(state, payload) {
      state.currentDashboard = parseInt(payload)
    },
    setCurrentDashboard(state, payload) {
      let newCollection = { ...state.collection }
      newCollection[payload.dashboardId] = payload.data
      Vue.set(state, 'collection', newCollection)
      Vue.set(state, 'currentTripDashboardId', parseInt(payload.dashboardId))

      // Set initial view mode for non-customer users who are also operators
      // Use Vue.nextTick to ensure the getters are updated after state changes
      Vue.nextTick(() => {
        const currentUser = TripDashboardStore.getters.currentRealUser
        const currentViewMode = TripDashboardStore.state.Users.currentViewMode
        
        // Only set initial view mode if:
        // 1. Current user is an operator
        // 2. View mode is not already set (O.isNone)
        if (currentUser && TripDashboardStore.getters.currentRealUserIsOperator && O.isNone(currentViewMode)) {
          // Use the getter to check if current user is in userViewers (after state is updated)
          const tripUserViewers = TripDashboardStore.getters.TripUserViewers || []
          const isCurrentUserInViewers = tripUserViewers.some(viewer => viewer.id === currentUser.id)
          
          if (isCurrentUserInViewers) {
            // Default to OPERATOR_VIEW for non-customer operators
            TripDashboardStore.commit('setViewMode', O.some(TripDashboardViewModes.OPERATOR_VIEW))
          }
        }
      })
    },
    updateTripUsers(state, payload) {
      let newTripCollection = { ...state.collection }
      newTripCollection[state.currentTripDashboardId].users = payload
      TripDashboardStore.commit('setClientUsers', payload)
      Vue.set(state, 'collection', newTripCollection)
    },
    updateTripUserViewers(state, payload) {
      let newTripCollection = { ...state.collection }
      newTripCollection[state.currentTripDashboardId].userViewers = payload
      Vue.set(state, 'collection', newTripCollection)

      // If current user is an operator and is in userViewers, set to OPERATOR_VIEW by default
      // This ensures operators maintain admin view when added as non-customer users
      const currentUser = TripDashboardStore.getters.currentRealUser
      if (currentUser && TripDashboardStore.getters.currentRealUserIsOperator) {
        const isCurrentUserInViewers = payload.some(viewer => viewer.id === currentUser.id)
        if (isCurrentUserInViewers) {
          const currentViewMode = TripDashboardStore.state.Users.currentViewMode
          // Only set if no view mode is currently set (O.isNone)
          if (O.isNone(currentViewMode)) {
            TripDashboardStore.commit('setViewMode', O.some(TripDashboardViewModes.OPERATOR_VIEW))
          }
        }
      }
    },
    updateTripEventsAndTodoItems(state, payload) {
      let newTripCollection = { ...state.collection }
      newTripCollection[state.currentTripDashboardId].calendar.custom_events = payload.custom_events
      newTripCollection[state.currentTripDashboardId].events = payload.events
      newTripCollection[state.currentTripDashboardId].todo_items = payload.todo_items
      Vue.set(state, 'collection', newTripCollection)
    },
    updateTripDashboardOmitTermsAndConditionsSignature(state, payload) {
      const tripDashboard = state.collection[state.currentTripDashboardId]
      if (tripDashboard) {
        tripDashboard.omit_terms_and_conditions_signature = payload === 1
      }
    },
    updateTripLogo(state, payload) {
      Vue.set(state, 'tripLogo', payload)
    },
    updateClientPifAccess(state, { clientId, value }) {
      const dashboard = state.collection[state.currentTripDashboardId];
      if (!dashboard || !dashboard.users) return;

      const clientIndex = dashboard.users.findIndex(c => c.id === clientId);
      if (clientIndex === -1) return;

      Vue.set(dashboard.users[clientIndex], 'has_access_to_all_pifs', value === 1);
      Vue.set(dashboard, 'users', [...dashboard.users]);
      const clientInClients = _find(dashboard.clients, c => c.id === clientId)
      if (clientInClients) {
        Vue.set(clientInClients, 'has_access_to_all_pifs', value === 1)
      }
    },
    addClientIfNotExists(state, user) {
      if (!Array.isArray(state.clients)) {
        state.clients = []
      }
      if (!state.clients.some(client => client.id === user.id)) {
        state.clients.push(user)
      }
    },

    removeClientsNotInList(state, remainingUserIds) {
      if (!Array.isArray(state.clients)) {
        state.clients = []
      }
      if (Array.isArray(remainingUserIds)) {
        state.clients = state.clients.filter(client => remainingUserIds.includes(client.id))
      } else {
        console.error("remainingUserIds should be an array")
      }
    }
  },
  actions: {
    setupTripResources(context, payload) {
      if (payload && payload.id) {
        context.commit('switchCurrentDashboard', payload.id)
      }
    },
    updateTripDashboardOmitTermsAndConditionsSignature(context, payload) {
      context.commit('updateTripDashboardOmitTermsAndConditionsSignature', payload)
    },
    updateClientPifAccess(context, payload) {
      context.commit('updateClientPifAccess', payload)
    },
    updateTripLogo(context, payload) {
      context.commit('updateTripLogo', payload)
    }
  },
  getters: {
    // @todo refactor/rename
    Trip: (state, getters) => {
      return getters.currentTripDashboard || {}
    },
    // @todo refactor/rename
    Trips: (state, getters) => {
      return getters.tripDashboards
    },
    tripDashboards: state => state.collection,
    currentTripDashboard: state =>
      state.currentTripDashboardId ? state.collection[state.currentTripDashboardId].data : null,
    currentTripDashboard_raw: state =>
      state.currentTripDashboardId ? state.collection[state.currentTripDashboardId] : null,
    currentClientTrip: (state, getters) => {
      return getters.currentTripDashboard && getters.currentTripDashboard.trip
        ? getters.currentTripDashboard.trip
        : null
    },
    currentTripDashboardId: state => {
      return state.currentTripDashboardId
    },
    logo: state => {
      if (state.tripLogo) {
        return  state.tripLogo
      }
      if (state.currentTripDashboardId) {
        return state.collection[state.currentTripDashboardId].logo
      }
    }
  }
}
